export default __webpack_public_path__ + "static/media/otp-message.cb168561.jpg";